
// import RMDBLogo from "../../images/react-movie-logo.svg"
import RMDBLogo from "../../images/default-monochrome-white.svg"
import TMDBLogo from "../../images/tmdb_logo.svg"
import { Wrapper, Content, LogoImg, TMDBLogoImg  } from "./Header.styles"
import { Link } from "react-router-dom"

const Heeader = () => {
    return (
        <Wrapper>
            <Content>
                <Link to="/"><LogoImg  src={RMDBLogo} alt="RMDB-logo"/></Link>
                <TMDBLogoImg src={TMDBLogo} alt="TMDB-logo"/>
            </Content>
        </Wrapper>
    )
}



export default Heeader
